(() => {
    Metro.i18n.add("hi", {
        weekStart: 0,

        january: "जनवरी",
        february: "फरवरी",
        march: "मार्च",
        april: "अप्रैल",
        may: "मई",
        june: "जून",
        july: "जुलाई",
        august: "अगस्त",
        september: "सितंबर",
        october: "अक्टूबर",
        november: "नवंबर",
        december: "दिसंबर",

        january_short: "जन",
        february_short: "फर",
        march_short: "मार्च",
        april_short: "अप्रै",
        may_short: "मई",
        june_short: "जून",
        july_short: "जुल",
        august_short: "अग",
        september_short: "सित",
        october_short: "अक्टू",
        november_short: "नव",
        december_short: "दिस",

        sunday: "रविवार",
        monday: "सोमवार",
        tuesday: "मंगलवार",
        wednesday: "बुधवार",
        thursday: "गुरुवार",
        friday: "शुक्रवार",
        saturday: "शनिवार",

        sunday_short: "रवि",
        monday_short: "सोम",
        tuesday_short: "मंगल",
        wednesday_short: "बुध",
        thursday_short: "गुरु",
        friday_short: "शुक्र",
        saturday_short: "शनि",

        sunday_short_2: "र",
        monday_short_2: "सो",
        tuesday_short_2: "मं",
        wednesday_short_2: "बु",
        thursday_short_2: "गु",
        friday_short_2: "शु",
        saturday_short_2: "श",

        label_ok: "ठीक है",
        label_cancel: "रद्द करें",
        label_done: "समाप्त",
        label_today: "आज",
        label_now: "अभी",
        label_clear: "साफ करें",
        label_help: "मदद",
        label_yes: "हाँ",
        label_no: "नहीं",
        label_random: "यादृच्छिक",
        label_save: "सहेजें",
        label_reset: "रीसेट करें",
        label_submit: "जमा करें",
        label_add_user_color: "रंगों में जोड़ें",
        label_send: "भेजें",
        label_accept: "स्वीकार करें",
        label_cookies_title: "यह साइट कुकीज़ का उपयोग करती है",
        label_cookies_text:
            "यह वेबसाइट यह सुनिश्चित करने के लिए कुकीज़ का उपयोग करती है कि आपको हमारी वेबसाइट पर सबसे अच्छा अनुभव मिले।",
        label_choose_file: "फ़ाइलें चुनें",
        label_drop_file: "यहां क्लिक करें या फ़ाइलें छोड़ें",
        label_files_selected: "{n} फ़ाइलें चुनी गईं",

        label_days: "दिन",
        label_hours: "घंटे",
        label_minutes: "मिनट",
        label_seconds: "सेकंड",
        label_month: "महीना",
        label_months: "महीने",
        label_day: "दिन",
        label_year: "साल",
        label_years: "साल",

        label_rows_count: "दिखाएं:",
        label_search: "खोजें:",
        label_table_info: "$1 से $2 तक $3 प्रविष्टियां दिखा रहा है",
        label_prev: "पिछला",
        label_next: "अगला",
        label_all: "सभी",
        label_inspector: "निरीक्षक",
        label_goto_page: "पृष्ठ पर जाएं",
        label_enter_page: "पृष्ठ दर्ज करें...",
        label_empty: "दिखाने के लिए कुछ नहीं",
        label_user_colors: "उपयोगकर्ता रंग",
        label_tiles: "टाइल्स",
        label_list: "सूची",
        label_load_more: "और लोड करें",
        label_buy: "खरीदें",
        label_buy_now: "अभी खरीदें",
        label_buy_today: "आज खरीदें",
        label_download: "डाउनलोड करें",
        label_search_results: "खोज परिणाम",
        label_add: "जोड़ें",
        label_edit: "संपादित करें",
        label_delete: "हटाएं",
        label_new: "नया",
        label_sell: "बेचें",
        label_details: "विवरण",
        label_sorting: "छंटाई",
        label_finish: "समाप्त करें",
        label_play: "चलाएं",
        label_pause: "रोकें",
        label_stop: "बंद करें",
        label_mute: "म्यूट करें",
        label_loop: "दोहराएं",

        label_on: "चालू",
        label_off: "बंद",

        label_rename_tab: "टैब का नाम बदलें",
        label_close_tab: "टैब बंद करें",
        label_close_other_tabs: "अन्य टैब बंद करें",
        label_close_tabs_left: "बाएं टैब बंद करें",
        label_close_tabs_right: "दाएं टैब बंद करें",
        label_close_all_tabs: "सभी टैब बंद करें",
        label_close_inactive_tabs: "निष्क्रिय टैब बंद करें",

        label_clear_input: "इनपुट साफ करें",
        label_reveal_password: "पासवर्ड दिखाएं",
        label_hide_password: "पासवर्ड छिपाएं",
        label_generate_random: "यादृच्छिक मान उत्पन्न करें",
        label_search_input: "दर्ज किए गए मान को खोजें",

        label_note: "नोट",
        label_tip: "सुझाव",
        label_info: "जानकारी",
        label_warning: "चेतावनी",
        label_question: "प्रश्न",
        label_error: "त्रुटि",
        label_success: "सफलता",
        label_caution: "सावधानी",
        label_alert: "चेतावनी",
        label_bug: "बग",
        label_fuck: "धत्त",
        label_important: "महत्वपूर्ण",
        label_shit: "बकवास",
        label_air: "हवा",

        label_select_all: "सभी का चयन करें",
        label_select_more: "चुनें...",
        label_select: "चुनें",
        label_filter: "फ़िल्टर",

        label_collapse: "संकुचित करें",
        label_attach: "संलग्न करना",
    });
})();
